import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { List } from "immutable";
import * as React from "react";
import { partition } from "../../util";
import { Loader } from "../loader";
import { loadFormstackForm } from "./formstack_api";
const initialState = {
    form: {
        kind: null,
        status: null
    }
};
export const formstackBlockClasses = {
    blockClassName: 'block block--form container--sg align--center',
    innerClassName: 'block__inner',
    contentClassName: 'block__content'
};
let isMounted = false;
let previousFormHeight = -1;
export class InnerHTML extends React.Component {
    componentWillUnmount() {
        isMounted = false;
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            ref: async (divRef)=>{
                if (!this.props.html || !divRef || divRef && divRef.innerHTML != '') return;
                divRef.innerHTML = ''; // Clear the container
                var targetDiv = document.createElement('div');
                var parsedDocument = new DOMParser().parseFromString(this.props.html, "text/html");
                var body = parsedDocument.getElementById('fsLocal');
                // Insert classname if necessary below
                targetDiv.className = body.className + " example-classname";
                targetDiv.id = body.id;
                targetDiv.innerHTML = body.innerHTML;
                const links = List(parsedDocument.getElementsByTagName('link')).filter((link)=>!link.href.includes('light.css'));
                const promises = links.map((link)=>new Promise((resolve)=>link.onload = ()=>resolve(link.href))).toArray();
                links.forEach((link)=>divRef.appendChild(link));
                // Prepare copy of live Element list
                const copy_scripts = List(targetDiv.getElementsByTagName('script'));
                // Remove scripts from initial html (done by reference)
                copy_scripts.forEach((x)=>x.remove());
                // When all external CSS has loaded, add the processed form div to the DOM
                await Promise.all(promises).then(()=>divRef.appendChild(targetDiv));
                // Load the scripts, first external then inline scripts
                const [linkedScripts, inlineScripts] = partition(copy_scripts, (x)=>x.src && x.src.length > 1);
                const scriptLoaders = linkedScripts.map((x)=>new Promise((resolve, reject)=>{
                        const s = document.createElement('script');
                        s.src = x.src;
                        s.async = false;
                        s.onload = (_)=>resolve(s.src);
                        s.onerror = (_)=>reject(s.src);
                        divRef.firstChild.appendChild(s);
                    })).toArray();
                // Wait for external scripts to load
                await Promise.all(scriptLoaders).catch((src)=>console.error("failed to load", src));
                // Append inline scripts
                inlineScripts.forEach((x)=>{
                    const s = document.createElement('script');
                    s.text = x.text;
                    divRef.firstChild.appendChild(s);
                });
                // Execute formstack library function to initialize form
                window.loadFormstack();
            // Scrolling logic
            // let checkHeight = () => setTimeout(() => {
            //   if (!isMounted) return
            //   let formDiv: HTMLElement = document.querySelector('#fsLocal')
            //   let currentHeight = formDiv.offsetHeight
            //   if (previousFormHeight == -1) { previousFormHeight = currentHeight }
            //   if (previousFormHeight != currentHeight) {
            //     // scrollTo
            //     formDiv.scrollIntoView(false)
            //   }
            //   previousFormHeight = currentHeight
            //   checkHeight()
            // }, 500)
            // checkHeight()
            }
        });
    }
    constructor(prop){
        super(prop);
        this.state = {};
        isMounted = true;
        previousFormHeight = -1;
    }
}
export class FormstackBlock extends React.Component {
    componentDidMount() {
        loadFormstackForm(this.props.formId).then((result)=>this.setState((prevState)=>({
                    ...prevState,
                    form: result
                })));
    }
    render() {
        const form = this.state.form;
        let formEl;
        if (form.kind == null) {
            formEl = /*#__PURE__*/ _jsxs("div", {
                className: "form form--formstack form--formstack-loading",
                children: [
                    "Het formulier wordt geladen...",
                    /*#__PURE__*/ _jsx(Loader, {})
                ]
            });
        }
        if (form.kind == 'result') {
            formEl = /*#__PURE__*/ _jsx("div", {
                className: "form form--formstack form--formstack-loaded",
                children: /*#__PURE__*/ _jsx(InnerHTML, {
                    html: form.value.html
                })
            });
        } else {
            formEl = /*#__PURE__*/ _jsx("div", {
                className: "form form--formstack form--formstack-failed",
                children: "Het formulier kon helaas niet geladen worden. Herlaad de pagina of neem contact op met De Nieuwe Bibliotheek."
            });
        }
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("section", {
                    className: "block block--form container--sg align--center",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "block__inner",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "block__content",
                            children: formEl
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("hr", {})
            ]
        });
    }
    constructor(props){
        super(props);
        this.state = initialState;
    }
}
